/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import type { DivProps } from 'typings';
import UDHeaderTitle from 'ud-ui/components/header-title';
import { useMainLayout } from 'ud-ui/layout/main/context';
import * as S from './styles';
import { useParams } from 'react-router-dom';
import { UDTable } from 'ud-ui/components/table';

interface IProps extends DivProps {}

function ComponentPage(props: IProps) {
  const { ...rest } = props;
  const { setHeaderContent } = useMainLayout();
  const params = useParams();
  const { componentName } = params;

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>Компонент - {componentName ?? '???'}</UDHeaderTitle>);
    return () => setHeaderContent(null);
  }, [componentName, setHeaderContent]);

  if (!componentName) return null;

  switch (componentName) {
    case 'table':
      return (
        <S.MainBlock {...rest}>
          <UDTable />
        </S.MainBlock>
      );
    default:
      return null;
  }
}

export default ComponentPage;
